export async function getResponseContent(response) {
    try {
        const text = await response.text();
        try {
            return JSON.parse(text);
        } catch (e) {
            return { message: text };
        }
    } catch (error) {
        throw new Error('Failed to read response');
    }
}

// export class RequestError extends Error {
//     constructor(message, status, content) {
//         super(message);
//         this.status = status;
//         this.content = content;
//     }
// }


export class RequestError extends Error {
    constructor(message, status, content = {}) {
        super(message);
        this.name = 'RequestError';
        this.status = status;
        Object.assign(this, content);
    }
}
